<script>
    import axios from "axios";
    import { io } from "socket.io-client";
    import { copy } from "./util.js";
    import QRCode from "easyqrcodejs";
    import { SyncLoader, Circle } from "svelte-loading-spinners";
    import { toasts, invoices } from "./stores.js";
    import Modal from "./atoms/Modal.svelte";
    import Container from "./atoms/Container.svelte";
    import { postInvoice, formatInvoice } from "./api/invoice.js";
    import { onMount } from 'svelte';
    import { createEventDispatcher } from 'svelte';
    import CopyClipBoard from './organisms/CopyClipBoard.svelte'

    export let address;
    export let fundTitle;
    export let price = 20;
    export let fundId;

	const dispatch = createEventDispatcher();

    let btcRate;
    let qr_code;
    let invoice = 0;
    let amount = 0;
    let _WebSocket = WebSocket;
    let id = "";
    let ws;
    let settled = false;
    let QR;

    $: id = null
    $: copy_class = "uncopied"
    $: addressElement = null
    $: count_down_time = 0
    $: payments = 0
    $: due = 0

    $: distance = count_down_time - Date.now()

    $: hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    $: minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    $: seconds = Math.floor((distance % (1000 * 60)) / 1000);
    $: formated_seconds = (seconds > 9 ? seconds : "0" + seconds);
    $: formated_minutes = (minutes > 9 ? minutes : "0" + minutes);
    $: loading = true

    const updateInvoice = () => {
        let ivs = invoices.getInvoice(fundTitle);
        if (ivs.length > 0) {
            count_down_time = ivs[0].expirationTime
        }
    }

    $: {
        invoices.subscribe( v => v.filter(n => {
            if (n.id == fundTitle && n.invoice.price == price) {
                invoice = n.invoice
                distance =  invoice.expirationTime - Date.now()
                count_down_time = invoice.expirationTime
                amount = invoice.btcDue
                btcRate = invoice.rate
                address = invoice.bitcoinAddress
                id = invoice.id
                loading = false
                if (qr_code) {
                    QR = new QRCode(qr_code, {
                        text: formatInvoice(invoice.bitcoinAddress, invoice.btcDue),
                        logoBackgroundTransparent: true,
                        logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/BTC_Logo.svg/2000px-BTC_Logo.svg.png"
                    })
                }
            }
        }))
    }

    $: if (id != "" && id != null) {
        ws = new _WebSocket("ws://api.plithos.fund/ws?invoice_id=" + id)
        ws.onmessage = event => {
            let data = event.data;
            if (data != "") {
                let json = JSON.parse(data);
                console.log(json.type)
                switch(json.type) {
                // lmao  ^
                    case "NewPayment":
                        amount = json.btc_due;
                        payments = json.payments
                        if (QR) {
                            QR.makeCode(formatInvoice(address, amount))
                        }
                        break;

                    case "InvoiceSettled":
                        settled = true;
                        break;

                    case "InvoiceExpired":
                        distance = 0;
                        ws.close(200)
                        break;
                }

            }
        }
    }

    onMount(() => {
        setInterval(() => {
            distance = count_down_time - Date.now()
        })

        postInvoice(fundTitle, {
            "price": price,
            "currency": "USD",
            "orderId": "something",
            "itemDesc": "item description",
            "posData": fundId 
        })
        console.log($invoices)
    });

    const copy_address = () => {
        const app = new CopyClipBoard({
            target: document.getElementById('clipboard'),
            props: { copyText: address }
        })
        app.$on('success', () => toasts.pushToast("address copied", "success"));
        app.$on('err', () => toasts.pushToast("error copying address", "error"));
        app.$destroy();
    }
</script>

<div class="container">
    {#if settled}
        <div class="exit">
            <i on:click={() => dispatch('close')} class="close-icon ui close icon"/>
        </div>
        <img src="Donation.svg" style="width: 10rem; margin-top: 2rem;" />
        <h3 style="margin-top: 3rem; text-align: center;">Thank You For Your Contribution!</h3>
    {:else}
        {#if loading}
            <Modal>
                <div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
                    <Container br="0.4rem" height={2}>
                        <div style="display: flex; flex-direction: column; align-items: flex-start;">
                            <h3 style="margin-bottom: 0px;">Loading Invoice</h3>
                            <p style="margin-top: 0px;">Please wait..</p>
                        </div>
                        <div style="display: flex; flex-direction: column; align-items: center;">
                            <div style="margin-block: 2rem;">
                                <SyncLoader color="#17C3B2" duration="1s" size="2" unit="rem"/>
                            </div>
                        </div>
                    </Container>
                </div>
            </Modal>
        {:else}
            {#if distance > 1000}
            <div class="status">
                <h4 style="display: flex; align-items: center; margin: 0px;" class={distance < (60 * 60 * 20) ? "red": ""}>
                    {distance < (60 * 60 * 20) ? "Expiring soon..." : "Awaiting payment..."}
                </h4>
                <div style="display: flex;">
                    {(hours + ":" + formated_minutes + ":" + formated_seconds)}
                    <span style="width: 0.6rem;"/> 
                    <Circle unit="rem" size={1.2} color="#17C3B2"/>
                </div>
            </div>
                <div class="divy" style="margin-bottom: 1rem; margin-top: 0px;"></div>
                <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                    <p style="margin: 0px; text-align: left;">
                        ${price} USD
                    </p>
                    <p style="margin: 0px; text-align: right;">
                        {amount} BTC
                    </p>
                </div>
                <div style="display: flex; justify-content: space-between; text-align: right; width: 100%;">
                    <p style="font-size: 12px; margin: 0px; margin-top: 0.2rem;">
                        {payments} {payments == 1 ? "payment" : "payments"}
                    </p>
                    <p style="font-size: 12px; margin: 0px; margin-top: 0.2rem;">
                        1 BTC = {btcRate} USD
                    </p>
                </div>
                <div class="divy" style="margin-bottom: 1rem;"></div>
                <div id="clipboard"></div>
                {#await invoice}
                    reee
                {:then}
                    <div bind:this={qr_code}/>
                {/await}
                    
                <div class="divy"></div>
                <div class="address-header">
                    <p>BTC Address</p>
                    <i on:click={copy_address} class={"clone icon " + copy_class}></i>
                </div>
                <div class="address">
                    <p bind:this={addressElement} class="address-text">
                        {address} 
                    </p>
                </div>
                <div class="close">
                    <button 
                        on:click={() => dispatch('close')}
                        class="b dim br2 ph3 pv2 mb2 dib white bg-brand-red"
                    >
                    Cancel Donation
                    </button>
                </div>
            {:else}
                <div style="display: flex; flex-direction: column; align-items: flex-start; width: calc(245px + 2rem); margin-top: 0px; margin-bottom: 1rem; text-align: left;">
                    <h4 style="display: flex; align-items: flex-start; margin-top: 0px;" class="red">
                        Invoice expired
                    </h4>
                    <h3>What Happened?</h3>
                    <p style="font-size: 14px; margin: 1rem; margin-left: 0px; text-align: left; line-height: 1.4;">
                        This invoice has expired. Invoices are only valid for 180 minutes. You can refresh the page to open a new invoice.
                    </p>
                    <p style="font-size: 14px; margin: 1rem; margin-left: 0px; text-align: left; line-height: 1.4;">
                        If you have sent funds and we have not recieved it yet, your order will still be processed when the funds are recieved.
                    </p>
                    <p style="font-size: 14px; margin: 0px; text-align: left; line-height: 1.4;">
                        <span style="font-weight: bold;">Invoice ID: </span>{invoice.id}
                    </p>
                    <p style="font-size: 14px; margin: 0px; margin-top: 0.2rem; margin-left: 0px; text-align: left; line-height: 1.4;">
                        <span style="font-weight: bold;">Fund ID: </span>{fundId}
                    </p>
                </div>
                <div class="close">
                    <button 
                        on:click={() => location.reload()}
                        class="b dim br2 ph3 pv2 mb2 dib white bg-brand-red"
                    >
                        Refresh
                    </button>
                </div>
            {/if}
        {/if}
    {/if}
</div>

<style>
    .exit {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        width: 100%;
    }
    .close-icon {
        margin-top: 0px !important;
        color: #ccc;
    }
    .close-icon:active, .close-icon:hover {
        color: #F25F5C;
    }
    .address-text {
        text-align: center;
        overflow-wrap: anywhere;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }

    .divy {
        margin-top: 1rem;
        height: 1px;
        background-color: #CCC;
        width: 100%;
    }
    .address {
        width: 100%;
        height: fit-content;
        border-radius: 4px;
        border-style: solid;
        border-width: 1px;
        border-color: #CCC;
        padding-left: 0.25rem;
        padding-right: 0.25rem;
        font-size: 12px;
    }
    .address-header {
        display: flex;
        height: 1rem;
        padding-top: 1rem;
        margin-bottom: 0.8rem;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding-bottom: 0.4rem;
    }
    h1 {
        margin-bottom: 0.4rem;
        margin-top: 0.6rem;
        text-align: center;
    }
    h3 {
        margin-top: 0px;
    }
    .copied {
        height: 1rem;
        filter: invert(48%) sepia(33%) saturate(1365%) hue-rotate(179deg) brightness(102%) contrast(103%);
        user-select: none;
        cursor: pointer;
    }
    .uncopied {
        user-select: none;
        cursor: pointer;
    }
    p {
        text-align: center;
    }
    .close {
        margin-top: 1.2rem;
    }
    .container {
        background-color: white;
        -webkit-box-shadow: 3px 6px 22px 0px rgba(0,0,0,0.75);
        -moz-box-shadow: 3px 6px 22px 0px rgba(0,0,0,0.75);
        box-shadow: 3px 6px 22px 0px rgba(0,0,0,0.75);

        border-radius: 1rem;

        padding: 1rem;

        display: flex;
        flex-direction: column;
        align-items: center;

        width: calc(100vw - 4rem);
        height: fit-content;

        margin-left: 1rem;
        margin-right: 1rem;
        position: relative;
    }
    @media only screen and (min-width: 768px) {
        .container { 
            width: -moz-fit-content;
            height: -moz-fit-content;
        }
    }
    .cancel-button {
        background-color: #F25F5C !important;
    }
    .status {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.6rem;
        width: 100%;
    }
    h3 {
        margin-bottom: 0.2rem;
    }
    .red {
        color: #F25F5C;
    }
</style>
